import { ChIcon } from '../../../../assets/svg/ch';
import { EngIcon } from '../../../../assets/svg/en';
import { KzIcon } from '../../../../assets/svg/kz';
import { RuIcon } from '../../../../assets/svg/ru';
import { LangEnum } from '../../../../helpers/lang';

export const FLAGS = {
  [LangEnum.RU]: <RuIcon />,
  [LangEnum.KZ]: <KzIcon />,
  [LangEnum.CH]: <ChIcon />,
  [LangEnum.EN]: <EngIcon />,
};

export const LANG_OPTIONS = [
  { id: LangEnum.RU, label: 'Русский', mobileLabel: 'RU' },
  { id: LangEnum.KZ, label: 'Қазақша', mobileLabel: 'KZ' },
  { id: LangEnum.EN, label: 'English', mobileLabel: 'EN' },
  { id: LangEnum.CH, label: '中文', mobileLabel: 'ZH' },
];
